import React, { useCallback } from "react";
import { Checkbox, FormControl, FormControlLabel, Grid, Radio, RadioGroup, Stack, Typography } from "@mui/material";
import { useAppDispatch, useAppSelector } from "../../store";
import { setPreferencesPartial } from "../../store/expertise/expertise.reducer";
import { Link, Title } from "../shared/Texts";
import { SaisieInfosFacturationSollicitation } from "../../../core/apis/monsisra/generated";

export default function InformationsFacturation() {
	const dispatch = useAppDispatch();
	const { preferences, links } = useAppSelector((s) => s.expertise);

	const onRadioSelected = useCallback(
		(e: React.ChangeEvent<HTMLInputElement>) => {
			dispatch(
				setPreferencesPartial({
					preferencesFacturationExpert: {
						nir: e.target.value as SaisieInfosFacturationSollicitation,
					},
				})
			);
		},
		[dispatch]
	);

	const onCheckboxSelected = useCallback(
		(e: React.ChangeEvent<HTMLInputElement>) => {
			dispatch(
				setPreferencesPartial({
					preferencesFacturationExpert: {
						numeroDemandeurRequis: e.target.checked,
					},
				})
			);
		},
		[dispatch]
	);

	if (!preferences) return null;

	return (
		<Grid container direction={"column"} spacing={2}>
			<Grid item>
				<Title text={"Facturation"} />
			</Grid>
			<Grid item>
					<Stack>
						<Typography fontStyle={"italic"} fontSize={"smaller"}>
							Les actes de téléexpertise sont rémunérés pour l'expert comme pour le demandeur. Chaque professionnel expert (requis) ou demandeur (requérant) a besoin du numéro de sécurité sociale (NIR) du patient et du numéro de facturation de l'autre professionnel (numéro <strong>AMELI</strong> pour un libéral, numéro <strong>FINESS/code spécialité</strong> pour un professionnel en établissement){" "}
							<Link text="(en savoir plus)" href={links.infosFacturation} />
						</Typography>

					</Stack>
			</Grid>
			<Grid item>
				<FormControl component="fieldset">
					<RadioGroup value={preferences.preferencesFacturationExpert?.nir} onChange={onRadioSelected} name="radio-buttons-group">
						<FormControlLabel
							value={SaisieInfosFacturationSollicitation.Obligatoires}
							control={<Radio />}
							label={"Je souhaite que le NIR soit demandé obligatoirement au requérant" }
						/>
						{preferences.preferencesFacturationExpert?.nir === SaisieInfosFacturationSollicitation.Obligatoires && (
							<FormControlLabel
								control={<Checkbox onChange={onCheckboxSelected} checked={preferences.preferencesFacturationExpert?.numeroDemandeurRequis}/>}
								label={
									<>
										Demander également le numéro de facturation du requérant{" "}
										<Link text="(en savoir plus)" href={links.numeroFacturation} />
									</>
								}
								sx={{ marginLeft: "16px" }}
							/>
						)}
						<FormControlLabel
							value={SaisieInfosFacturationSollicitation.Optionnelles}
							control={<Radio />}
							label={"Je souhaite que le NIR soit demandé mais non obligatoire"}
						/>
						{preferences.preferencesFacturationExpert?.nir === SaisieInfosFacturationSollicitation.Optionnelles && (
							<FormControlLabel
								control={<Checkbox  onChange={onCheckboxSelected} checked={preferences?.preferencesFacturationExpert?.numeroDemandeurRequis} />}
								label={
									<>
										Demander également le numéro de facturation du requérant{" "}
										<Link text="(en savoir plus)" href={links.demanderNumeroFacturation} />
									</>
								}
								sx={{ marginLeft: "16px" }}
							/>
						)}
						<FormControlLabel
							value={SaisieInfosFacturationSollicitation.Invisibles}
							control={<Radio />}
							label={"Ne pas demander le NIR au requérant"}
						/>
					</RadioGroup>
				</FormControl>
			</Grid>
		</Grid>
	);
}
